<template>
  <label
    class="ms-radio"
    @keypress="keyDownActive"
    @focus="onFocus"
    @blur="onBlur"
    v-tooltip="tooltipMessage"
  >
    <input
      :modelValue="modelValue"
      ref="input"
      type="radio"
      :name="name"
      :value="keyValue"
      :checked="modelValue === keyValue"
      :disabled="disabled"
      :tabindex="0"
      @input="$emit('update:modelValue', keyValue)"
      @change="onChange"
    >
    <span class="checkmark" />
    <span
      v-if="label"
      class="ms-radio--text webkit-box-1"
      ref="labelEl"
    >{{ label }}</span>
  </label>
</template>
<script>
import { nextTick } from 'vue'
/* eslint-disable vue/require-default-prop */
export default {
  name: 'MsRadio',
  props: {
    modelValue: [String, Boolean, Number, Object],
    label: String,
    keyValue: [String, Boolean, Number, Object],
    name: String,
    // type: {
    //   default: 'radio',
    //   type: String,
    // },
    disabled: Boolean,
  },
  data () {
    return {
      focused: false,
      tooltipMessage: null,
    }
  },
  computed: {
    listeners () {
      return {
        // eslint-disable-next-line vue/no-deprecated-dollar-listeners-api
        ...this.$listeners,
      }
    },

  },
  methods: {
    keyDownActive (e) {
      e.preventDefault()
      switch (e.which) {
        case 32:
        case 13:
          this.$emit('update:modelValue', this.keyValue)
          this.$refs.input.focus()
          break
      }
    },
    onFocus (e) {
      const me = this
      me.focused = true
    },
    onBlur (e) {
      const me = this
      me.focused = false
    },
    onChange (e) {
      this.$emit('msChange', e)
    },
  },

  mounted () {
    var me = this
    nextTick(() => {
      var labelEl = me.$refs.labelEl

      if (labelEl?.scrollHeight > labelEl?.clientHeight) {
        me.tooltipMessage = me.label
      }
    })
  },
}
</script>
<style lang="scss" scoped>

@import '@/assets/scss/components/MsRadio.scss';
</style>
